import { BUSCAR_CUSTO_ITINERARIO } from '../../actions/types'

const initialState = undefined

export default function reducerBuscarCustoItinerario (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_CUSTO_ITINERARIO: {     
      const custoItinerario = action.payload.data;
      if (custoItinerario) {
        return custoItinerario;
      }
      return []
    }
    default: {
      return state
    }
  }
}
